import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { EntitySelectModule } from '../entity-select/entity-select.module';
import { RegisterModule } from '../register/register.module';
import { AutoAttendantKeyListComponent } from './auto-attendant-key-list.component';

@NgModule({
   declarations: [AutoAttendantKeyListComponent],
   exports: [AutoAttendantKeyListComponent],
   imports: [
      FormsModule,
      CommonModule,
      ReactiveFormsModule,
      LcsLoadingOverlayModule,
      ScrollingModule,
      LcsCallStatePipeModule,
      LcsResponsiveTableModule,
      MatIconModule,
      MatInputModule,
      EntitySelectModule,
      MatRadioModule,
      RegisterModule,
      MatButtonModule,
      LcsCallStatePipeModule,
      ScrollingModule,
      MatFormFieldModule,
   ],
   providers: [ConfirmationDialogService],
})
export class AutoAttendantKeyListModule {}
